import { OnboardingStep } from '../types'

export const defaultSteps: OnboardingStep[] = [
    {
        id: 'use-case',
        question: 'What would you like to use CommZone for?',
        options: [
            { id: 'create-content', label: 'Create content (Blogs, Slogans, articles)' },
            { id: 'analyze-content', label: 'Analyze my content or landing page' },
            { id: 'identify-audience', label: 'Identify my target audience or persona' },
            { id: 'generate-strategies', label: 'Generate strategies for my brand' },
            { id: 'automate-workflows', label: 'Automate workflows' },
            { id: 'not-sure', label: 'Not sure yet' },
        ],
    },
    {
        id: 'business-industry',
        question: 'What is your business industry?',
        type: 'single-select',
        hasOtherOption: true,
        options: [
            { id: 'personal-use', label: 'Personal Use' },
            { id: 'retail-ecommerce', label: 'Retail/E-commerce' },
            { id: 'healthcare', label: 'Healthcare' },
            { id: 'finance', label: 'Finance' },
            { id: 'influencer', label: 'Influencer' },
            { id: 'digital-media', label: 'Digital Media' },
            { id: 'fashion-beauty', label: 'Fashion & Beauty' },
            { id: 'marketing', label: 'Marketing' },
            { id: 'public-relations', label: 'Public relations' },
            { id: 'consulting', label: 'Consulting' },
            { id: 'non-profit', label: 'Non-profit' },
            { id: 'technology', label: 'Technology' },
            { id: 'other-specify', label: 'Other (please specify)' },
        ],
    },
    {
        id: 'organization-size',
        question: 'What size is your organisation?',
        subtitle: 'You can always update',
        type: 'single-select',
        options: [
            { id: 'only-me', label: 'Only Me' },
            { id: 'two-to-ten', label: '2-10' },
            { id: 'eleven-to-fifty', label: '11-50' },
            { id: 'fiftyone-to-hundred', label: '51-100' },
            { id: 'hundredone-to-twohundred', label: '101-200' },
            { id: 'twohundredone-plus', label: '201+' },
        ],
    },
    {
        id: 'challenges',
        question: 'What challenge are you hoping to solve?',
        subtitle: 'select all that apply',
        type: 'multi-select',
        hasOtherOption: true,
        options: [
            { id: 'low-customer-engagement', label: 'Low Customer Engagement' },
            { id: 'lack-of-ideas', label: 'Lack of content ideas' },
            { id: 'ineffective-landing', label: 'Ineffective landing page' },
            { id: 'other-specify', label: 'Other (please specify)' },
            { id: 'not-sure-yet', label: 'Not sure yet' },
        ],
    },
    {
        id: 'tone-style',
        question: 'What tone or style do you prefer for your content?',
        subtitle: 'You can always update',
        type: 'single-select',
        hasOtherOption: true,
        options: [
            { id: 'casual', label: 'Casual' },
            { id: 'professional', label: 'Professional' },
            { id: 'humorous', label: 'Humorous' },
            { id: 'playful-professional', label: 'Playful/professional' },
            { id: 'inspirational', label: 'Inspirational' },
            { id: 'other-specify', label: 'Other (please specify)' },
            { id: 'not-sure-yet', label: 'Not sure yet' },
        ],
    },
    {
        id: 'workspace-name',
        question: "You're almost there! Let's personalize your workspace.",
        subtitle: 'Give your workspace a name that reflects your team or project',
        type: 'text',
        inputPlaceholder: 'e.g., Marketing Team, Design Studio',
        options: [],
        primaryActionLabel: 'Next',
    },
    {
        id: 'invite-team',
        question: 'Invite people to your workspace',
        subtitle: 'You can skip this for now and invite team members later',
        type: 'invite',
        inputPlaceholder: 'colleague@yourcompany.com',
        options: [],
        primaryActionLabel: 'Complete Onboarding',
    },
]
